import { atom } from "recoil";

export const alertFormLoadingAtom = atom<boolean | undefined>({
  key: "alertFormLoadingAtom",
  default: undefined,
});
